import { SupportedLocales } from "..";
import { AGGClientV2 } from "../../clients/agg-client/agg-client-v2";
import { WAC_TO_CPAPI_LOCALE_MAP } from "../content-queries/constants";

import { graphql } from "./../../../src/graphql";

export type PaidLandingPersonaTypes = "unknown";

export type AnchorContent = {
    pageVariant: string;
    productId: string;
};

export type AnchorContentsResponse = Awaited<
    ReturnType<typeof getAnchorContents>
>;

export const DEFAULT_PERSONA: PaidLandingPersonaTypes = "unknown";

/**
 * @deprecated CPAPI is going to be deprecated in FY26.
 * Avoid using this function or introducing it's usage in new code.
 * Ask AC Team for more info.
 */
export const getAnchorContents = async (
    anchorContents: AnchorContent,
    aggClient = new AGGClientV2(),
    locale: SupportedLocales = "en"
) => {
    console.warn("Usage of GetAnchorContents is Deprecated!");
    const GET_ANCHOR_CONTENTS = graphql(`
        query GetAnchorContents($search: ContentPlatformSearchAPIv2Query!) {
            anchors(search: $search) {
                edges {
                    node {
                        name
                        pageVariant
                        persona {
                            id
                            name
                        }
                        product {
                            productNameId
                        }
                        headline {
                            name
                            subheading
                            planBenefits {
                                supportingAsset {
                                    url
                                    description
                                }
                                description
                                planFeatures {
                                    description
                                }
                            }
                        }
                        primaryMessage {
                            name
                            supportingExample {
                                proofpoint
                                supportingAsset {
                                    url
                                    description
                                }
                                heading
                                name

                                advocateQuote {
                                    advocateHeadshot {
                                        url
                                        description
                                    }
                                    advocateName
                                    advocateQuote
                                    advocateJobTitle
                                }
                            }
                        }
                        banner {
                            bannerImage {
                                description
                                url
                            }
                            backgroundImage {
                                url
                            }
                            text
                            url
                            urlText
                        }
                        results {
                            id
                            name
                            lozenge
                            subheading
                            asset {
                                url
                                description
                                details
                                title
                                fileName
                                contentType
                            }
                        }
                        socialProof {
                            name
                            customers {
                                logo {
                                    url
                                    description
                                }
                                altDarkLogo {
                                    url
                                    description
                                }
                            }
                        }
                        callToAction {
                            valueProposition
                            text
                            url
                        }
                    }
                }
            }
        }
    `);

    const cpapiLocale = WAC_TO_CPAPI_LOCALE_MAP[locale] || "en-US";

    const { data, error } = await aggClient.query(GET_ANCHOR_CONTENTS, {
        search: {
            queries: [
                {
                    first: 1,
                    withLocales: [cpapiLocale],
                    where: {
                        searchText: {
                            and: [
                                {
                                    exactlyMatching: {
                                        fieldNamed: "pageVariant",
                                        havingValues: [
                                            anchorContents.pageVariant
                                        ]
                                    }
                                },
                                {
                                    exactlyMatching: {
                                        fieldNamed: "product.productNameId",
                                        havingValues: [anchorContents.productId]
                                    }
                                },
                                {
                                    exactlyMatching: {
                                        fieldNamed: "persona.name",
                                        havingValues: ["unknown"]
                                    }
                                }
                            ]
                        }
                    }
                }
            ]
        }
    });
    if (error) {
        const errors = error.message.split("\n");
        errors.forEach((errorMessage) => {
            if (errorMessage !== "[GraphQL] String cannot represent value: {}")
                throw new Error(error.message);
        });
    }
    return data?.anchors?.edges;
};
